import(/* webpackMode: "eager" */ "/vercel/path0/src/app/labels/[slug]/page.tsx");
